import axios from "axios";
import {ENGINE_TC_MAKER} from "@/services/ConstantService";
import {GlobalService} from "@/services/GlobalService";
import {UrlService} from "@/services/UrlService";

export const EngineTcMakerService = {
  async getEngineTcMakers(params) {
    return await axios.get(ENGINE_TC_MAKER+UrlService.setQueryString(params)).then(response => {
      return response.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'GET ENGINE TC MAKER LIST SERVICE')
      return false
    })
  },
  async createEngineTcMaker(params) {
    return await axios.post(ENGINE_TC_MAKER,params).then(response => {
      return response.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'CREATE ENGINE TC MAKER SERVICE')
      return error?.response?.data
    })
  },

  async updateEngineTcMaker(params) {
    return await axios.put(ENGINE_TC_MAKER + `/${params.id}`,params).then(response => {
      return response.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'UPDATE ENGINE TC MAKER SERVICE')
      return error?.response?.data ?? false
    })
  },

  async deleteEngineTcMaker(params) {
    return await axios.delete(ENGINE_TC_MAKER + `/${params.id}`).then(response => {
      return response.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'DELETE ENGINE TC MAKER SERVICE')
      return false
    })
  },
}
